/**
 * Represents the time-related state of the current and previous animation frames.
 * 
 * Useful for calculating delta time, total elapsed time, and implementing
 * time-based animations or physics.
 */
export class TimeState {
  /**
   * Timestamp of the current animation frame in milliseconds.
   * This value is typically obtained via `performance.now()`.
   */
  now: number = 0;

  /**
   * Timestamp of the previous animation frame in milliseconds.
   */
  previous: number = 0;

  /**
   * Time difference between the current and previous frames in milliseconds.
   * Commonly used to calculate animation progress.
   */
  delta: number = 0;

  /**
   * Total time elapsed since the start of the animation or system in milliseconds.
   */
  elapsed: number = 0;
}
